import { NavLink } from "react-router-dom";

import {
  PERMISSIONS_ACTION,
  PERMISSIONS_MODEL,
} from "../library/utilities/constants/permissions";
import { Can } from "../ability/can";

const AppSidebar = () => {
  return (
    <div className="sidebar">
      <h3 className="sidebar-title">Admin Panel</h3>
      <Can I={PERMISSIONS_ACTION.USER_VIEW} a={PERMISSIONS_MODEL.USER}>
        <NavLink to="/users" className="sidebar-link">
          Users
        </NavLink>
      </Can>
      <Can I={PERMISSIONS_ACTION.ROLE_VIEW} a={PERMISSIONS_MODEL.ROLE}>
        <NavLink to="/user-roles" className="sidebar-link">
          Roles
        </NavLink>
      </Can>
      <Can
        I={PERMISSIONS_ACTION.CANDIDATE_VIEW}
        a={PERMISSIONS_MODEL.CANDIDATE}>
        <NavLink to="/candidate" className="sidebar-link">
          Candidates
        </NavLink>
      </Can>
      <Can I={PERMISSIONS_ACTION.TOPIC_VIEW} a={PERMISSIONS_MODEL.TOPIC}>
        <NavLink to="/topics" className="sidebar-link">
          Topics
        </NavLink>
      </Can>
      <Can
        I={PERMISSIONS_ACTION.TOPIC_RULE_VIEW}
        a={PERMISSIONS_MODEL.TOPIC_RULE}>
        <NavLink to="/topic-rules" className="sidebar-link">
          Topic Rules
        </NavLink>
      </Can>
      <Can
        I={PERMISSIONS_ACTION.INTERVIEW_QUESTION_VIEW}
        a={PERMISSIONS_MODEL.INTERVIEW_QUESTION}>
        <NavLink to="/interview-questions" className="sidebar-link">
          Interview Questions
        </NavLink>
      </Can>
        
        <NavLink to="/exam-reports" className="sidebar-link">
          Exam Reports
        </NavLink>
    
    </div>
  );
};

export default AppSidebar;
